import firebase from "firebase";

var firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAENivUBeZLKA95pFHK4INWwVzarHDl7Ck",
  authDomain: "strategic-links.firebaseapp.com",
  projectId: "strategic-links",
  storageBucket: "strategic-links.appspot.com",
  messagingSenderId: "274206755924",
  appId: "1:274206755924:web:524dfe3fedf68ddb4471c1"
});

var db = firebaseApp.firestore();

export { db };